import jsPDF from 'jspdf'
import moment from 'moment'

const HEADERS = [
  'Name',
  'Status',
  'Gateway',
  'Smart',
  'Leak',
  'Evac',
  'Meter',
  'Valve',
]

const colWidthsPt = [130, 56, 44, 44, 44, 44, 44, 44]

const baseFileStem = () =>
  `Billing Report — ${moment().format('YYYY-MM-DD')}`

const escapeCsvCell = val => {
  const s = val === null || val === undefined ? '' : String(val)
  if (/[",\n\r]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`
  }
  return s
}

const cellString = v => {
  if (v === 0 || v) {
    return String(v)
  }
  return ''
}

export const downloadBillingReportCsv = (rows, fileStem = baseFileStem()) => {
  const lines = [
    HEADERS.map(escapeCsvCell).join(','),
    ...rows.map(r =>
      [
        r.name,
        r.status,
        cellString(r.gateway),
        cellString(r.smart),
        cellString(r.leak),
        cellString(r.evac),
        cellString(r.meter),
        cellString(r.valve),
      ]
        .map(escapeCsvCell)
        .join(',')
    ),
  ]
  const blob = new Blob([`\ufeff${lines.join('\r\n')}`], {
    type: 'text/csv;charset=utf-8',
  })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `${fileStem}.csv`
  a.click()
  URL.revokeObjectURL(url)
}

export const downloadBillingReportPdf = (
  rows,
  fileStem = baseFileStem(),
  subtitle = ''
) => {
  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'pt',
    format: 'letter',
  })
  const pageW = doc.internal.pageSize.getWidth()
  const pageH = doc.internal.pageSize.getHeight()
  const margin = 36
  const tableLeft = margin
  const sumW = colWidthsPt.reduce((a, b) => a + b, 0)
  const scale = (pageW - margin * 2) / sumW
  const widths = colWidthsPt.map(w => w * scale)

  let y = margin
  doc.setFont('helvetica', 'bold')
  doc.setFontSize(14)
  doc.text('Billing Report', tableLeft, y)
  y += 20
  doc.setFont('helvetica', 'normal')
  doc.setFontSize(10)
  if (subtitle) {
    doc.text(subtitle, tableLeft, y)
    y += 16
  }
  doc.setFontSize(8)
  const headerTop = y
  const headerH = 18
  let x = tableLeft
  HEADERS.forEach((h, i) => {
    doc.setFillColor(240, 240, 240)
    doc.rect(x, headerTop, widths[i], headerH, 'FD')
    doc.setDrawColor(180, 180, 180)
    doc.rect(x, headerTop, widths[i], headerH, 'S')
    doc.text(h, x + 4, headerTop + 12)
    x += widths[i]
  })
  y = headerTop + headerH + 4
  doc.setDrawColor(0, 0, 0)

  const lineStep = 12

  rows.forEach(row => {
    const cells = [
      row.name,
      row.status,
      cellString(row.gateway),
      cellString(row.smart),
      cellString(row.leak),
      cellString(row.evac),
      cellString(row.meter),
      cellString(row.valve),
    ]
    const nameLines = doc.splitTextToSize(String(cells[0] || ''), widths[0] - 8)
    const rowH = Math.max(16, nameLines.length * lineStep + 4)

    if (y + rowH > pageH - margin) {
      doc.addPage()
      y = margin
    }

    const rowTop = y
    x = tableLeft
    cells.forEach((cell, i) => {
      const lines =
        i === 0
          ? nameLines
          : doc.splitTextToSize(String(cell ?? ''), widths[i] - 8)
      doc.setDrawColor(200, 200, 200)
      doc.rect(x, rowTop, widths[i], rowH, 'S')
      let ty = rowTop + lineStep
      lines.slice(0, 4).forEach(line => {
        doc.text(line, x + 4, ty)
        ty += lineStep
      })
      x += widths[i]
    })
    y = rowTop + rowH
  })

  doc.save(`${fileStem}.pdf`)
}
